import { AirCarrierEntity } from 'src/store/air-carrier/air-carrier.model';

export class AirCarrierViewModel implements AirCarrierEntity {
  public id: string;
  public code: string;
  public name: string;
  public abbreviation: string;
  public certificateNumber: string;
  public faaApiUserName: string;
  public faaApiToken: string;

  constructor(airCarrier: AirCarrierEntity) {
    Object.assign(this, airCarrier);
  }
}
